import React, { useEffect } from 'react';
import VrpLayout from './VrpLayout';
import { NavigatingAway } from './VrpNavigation';
import Sidebar from '../Sidebar/Sidebar';
import VrpMap from '../Map';
import { useVrp } from '../context/VrpContext';

/**
 * VRP Main Page Component
 * Integrates all sub-components and functionality
 * Now using VrpContext for state management
 */
export default function VrpPage() {
  // Use VRP context for all state management
  const { 
    // Navigation
    goToHome,
    isNavigatingRef,
    initialize,
    
    // UI state
    showPanel,
    setShowPanel
  } = useVrp();
  
  // Initialize component on mount
  useEffect(() => {
    initialize();
  }, [initialize]);

  // Check if navigating away
  if (isNavigatingRef.current) {
    return <NavigatingAway />;
  }

  return (
    <VrpLayout
      showPanel={showPanel}
      setShowPanel={setShowPanel}
      goToHome={goToHome}
      sidebar={<Sidebar />}
      map={<VrpMap />}
    />
  );
} 